export const SYNTH_VERSION = '0.13.3';
